export default {
  CHROME: 'CHROME',
  FIREFOX: 'FIREFOX',
  DESKTOP_SAFARI: 'DESKTOP_SAFARI',
  IE: 'IE',
  MOBILE_SAFARI: 'MOBILE_SAFARI',
  ETC: 'ETC',
};
